import { MEMBER_SKILLS } from '../api';

// Chip multi-select schopností. value = pole klíčů, onChange(nové pole).
// compact=true → menší čipy bez popisku (pro filtr).
export default function SkillPicker({ value = [], onChange, compact = false }) {
  const toggle = (key) => {
    if (value.includes(key)) onChange(value.filter((k) => k !== key));
    else onChange([...value, key]);
  };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
      {MEMBER_SKILLS.map((s) => {
        const on = value.includes(s.key);
        return (
          <button
            type="button"
            key={s.key}
            onClick={() => toggle(s.key)}
            aria-pressed={on}
            style={{
              display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2,
              textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit',
              padding: compact ? '6px 12px' : '10px 14px',
              borderRadius: compact ? 999 : 10,
              border: `1px solid ${on ? 'var(--red)' : 'var(--border)'}`,
              background: on ? 'var(--red-light)' : 'var(--surface)',
              color: on ? 'var(--red)' : 'var(--text-soft)',
              transition: 'border-color .15s, background .15s, color .15s',
            }}
          >
            <span style={{ fontWeight: 600, fontSize: compact ? '0.82rem' : '0.95rem' }}>{s.label}</span>
            {!compact && <span style={{ fontSize: '0.78rem', color: on ? 'var(--red)' : 'var(--text-muted)' }}>{s.desc}</span>}
          </button>
        );
      })}
    </div>
  );
}

// Zobrazení schopností jako drobné štítky (přehled členů).
export function SkillBadges({ skills }) {
  if (!skills || skills.length === 0) return <span className="text-muted">—</span>;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
      {skills.map((k) => (
        <span key={k} style={{
          fontSize: '0.72rem', fontWeight: 600, padding: '2px 8px', borderRadius: 999,
          background: 'var(--blue-light)', color: 'var(--blue)',
        }}>{k}</span>
      ))}
    </div>
  );
}
